export type PlanningStatus = 'ACTIVE' | 'COMPLETED' | 'POSTPONED';

export interface PlanningHistoryEntry {
  auditLogId: number;
  author: string;
  logTime: string;
  message: string;
}

export interface PlanningUser {
  userId: number;
  firstName: string;
  lastName: string;
  [key: string]: any;
}

export interface Planning {
  activityPlanningId: number | null;
  code: string;
  title: string;
  description: string;
  creatorUser: PlanningUser | null;
  assigneeUser: PlanningUser | null;
  dueDate: string | null;
  reminder: string | null;
  status: PlanningStatus;
  postponedReason: string | null;
  createTime?: string;
  updateTime?: string;
}

export interface PlanningPayload {
  title: string;
  description: string;
  assigneeUserId: number;
  dueDate: string;
}

export const PLANNING_STATUS_LABELS: Record<PlanningStatus, string> = {
  ACTIVE: 'Active',
  COMPLETED: 'Completed',
  POSTPONED: 'Postponed'
};

export function planningUserFullName(user?: PlanningUser | null): string {
  if (!user) {
    return '';
  }
  return `${user.lastName ?? ''} ${user.firstName ?? ''}`.trim();
}
